<template>
  <div class="list-foot">
    <span class="feedback" @click="goFeedback">{{$t('list.feedback')}}</span>
    <div class="memory-wrap clearfix">
      <div class="memory-progress-bar">
        <div class="memory-used memory-used-notebook" :style="{width: usedPercentage + notebookUsedPercentage + '%'}"></div>
        <div class="memory-used" :style="{width: usedPercentage + '%'}"></div>
      </div>
      <div class="memory-text">
        {{$t('list.used')}} {{memoryUsed}}/{{$t('list.total')}} {{memoryTotal}}
      </div>
      <div class="app-version">
        <span>{{version}}</span>
      </div>
    </div>
    <div class="product-memory-tip">
      <span class="circel"></span>
      <span>ET</span>
      <span class="circel notebook"></span>
      <span>{{$t('index.notebook')}}</span>
    </div>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
export default {
  name: 'listFoot',
  data () {
    return {
      memoryUsed: '',
      memoryTotal: '10GB',
      usedPercentage: 0,
      notebookUsedPercentage: 0,
      version: 0
    }
  },
  created () {
    this.version = Config.VERSION
    this.refreshUsage()
  },
  methods: {
    goFeedback: function () {
      this.$emit('goFeedback')
    },
    refreshUsage: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/user/etInfo?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          // console.log(response.body)
          this.memoryTotal = Math.round(response.body.usagesLimit / (1024 * 1024 * 1024)) + 'GB'
          let memoryEtUsed = response.body.usages / (1024 * 1024 * 1024)
          let memoryNotebookUsed = response.body.notebooksUsages / (1024 * 1024 * 1024)
          this.memoryUsed = (memoryEtUsed + memoryNotebookUsed).toFixed(2) + 'GB' // 不需要太精确
          this.usedPercentage = Math.round(response.body.usages * 100 / response.body.usagesLimit)
          if (response.body.notebooksUsages === '0') {
            this.notebookUsedPercentage = 0
          } else if (response.body.notebooksUsages > 0) {
            this.notebookUsedPercentage = Math.round(response.body.notebooksUsages * 100 / response.body.usagesLimit)
            if (this.notebookUsedPercentage <= 1) {
              this.notebookUsedPercentage = 1
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.list-foot
  width 100%
  height 50px
  line-height 50px
  position fixed
  left 0
  right 0
  bottom 0
  color #3d3d3d
  border-top 1px solid #ebebeb
  background-color #fff
  font-size 12px
  text-align left
  .feedback
    position absolute
    top 0
    left 27px
    cursor pointer
  .memory-wrap
    display block
    text-align center
    color #a5a5a5
    .memory-progress-bar
      display inline-block
      width 600px
      height 8px
      background-color #f5f5f5
      border-radius 4px
      margin-top 21px
      position relative
      .memory-used
        width 0%
        max-width 100%
        height 100%
        background-color #999
        border-radius 5px
        transition all 0.2s
        position absolute
        top 0
        left 0
        &.memory-used-notebook
          background-color #cacaca
    .memory-text
      display inline-block
      margin-left 25px
    .app-version
      float right
      opacity 0
  .product-memory-tip
    position absolute
    top 0
    right 20px
    .circel
      display inline-block
      width 19px
      height 19px
      border-radius 50%
      background-color #999
      vertical-align middle
      margin 0 6px 0 35px
      &.notebook
        background-color #cacaca
</style>



// WEBPACK FOOTER //
// src/components/ListFoot.vue